import request from '@/utils/request'
import base from "@/api/base";

export default {
    //查询版本权限
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/menu/getMenuVersionList`, params),
    //勾选版本权限
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/menu/updateMenuVersion`, params),
}